
import {IconLeftFormInputRight} from
    "./../../classes/iconsAndFormInputCombination/iconLeftFormInputRight/IconLeftFormInputRight.js";

import {SmetioPreloader} from
    "./../../classes/smetioPreloader/SmetioPreloader.js";

import {globalVar} from 
    "./../../variables/global_variables.js";

import {getCustomCheckbox} from "./getCustomCheckbox.js";

import {getInputTypeText} from "./getInputTypeText.js";

export async function createForm(formGlobalVarId) {
    /**** 
     * 
     * THIS FUNCTION TAKES AN ARRAY WHICH CONTAINS THE OBJECTS OF EACH ELEMENT/INPUT IN A FORM
     * 
     * FOR EXAMPLE
     * 
     * const privatePresale_stepOne_formInputArray = [

        {
            icon: "user",
            placeholder: "First name",
            value: "",
            type: "text",
            extra_class: "firstName",
            isRequire: "yes",
            errorHolderClass: "firstName_errorHolderClass",
            sanitizationFunc: ""
        }           


    ];
     * 
     * 

     * ****/

    const formInputArray = globalVar[formGlobalVarId]["inputs"];
    //const formId = globalVar["smetioForm_"+formId]["formId"] = formId;
    const formId = globalVar[formGlobalVarId]["formId"];

    ///formInputArray["formId"] = formId;

    let output = "";

    for(let key in formInputArray ){ 

        let formConent = "";
        let inputType = formInputArray[key]["type"];

        switch(inputType){

            case "customCheckbox": formConent = getCustomCheckbox(formInputArray[key], formId);

            break;

            default: formConent = getInputTypeText(formInputArray[key], formId);

        };
        
        output += formConent;

    }; 


    /**** 
     * 
     * GET THE GLOBALVAR ADDRESS OF THE FORM THIS WILL BE USED TO RETRIVE DATA FROM THE GLOBAL VARIABLE 
     * THAT ARE RELATED TO THE FORM
     * 
     * *****/

     //const globalVarAddr = formGlobalVarId["globalVarAddr"];


     /**** 
      * 
      * CREATE A SUBMIT BUTTON FOR THE FORM AND ADD IT TO THE FORM
      * 
      * THE CSS OF smetio-form-submitter IS IN THE smetioSmartBox.scss FILE BUT ONLY APPLIES WHEN THE BUTTON IS 
      * INSIDE A SMARTBOX
      * 
      * ****/

    const formSubmitButton = `

        <button 
            class=" clickable smetio-button smetio-form-submitter"
            data-smetio-form-holderClass="${globalVar[formGlobalVarId]["formHolder"]}"
            data-smetio-form-input-array="${formGlobalVarId}"
        >
            ${globalVar[formGlobalVarId]["submissionBtnText"]}

        </button>

    `;

    output += formSubmitButton;
    /**** 
     * 
     * ADD PRELOADER TO THE FORM AND TO THE GLOBALVARADDR OF THE FORM
     * THE PRELOADER WILL BE SHOWN WHEN AN AJAX REQUEST IS BEING MADE TO PREVENT USERS FROM INTERACTING
     * WITH THE FORM AND TO LET THEM KNOW THAT THE REQUEST IS BEING MADE
     * 
     * ****/
    let preloader = "";

    if( globalVar[formGlobalVarId]["addPreloader"] ){

        globalVar[formGlobalVarId]["ajaxPreloader"] = new SmetioPreloader();
        globalVar[formGlobalVarId]["ajaxPreloader"].extra_attributes = `data-state="spinner_on_top"`; 
        globalVar[formGlobalVarId]["ajaxPreloader"].display_state = "hide";

        preloader = globalVar[formGlobalVarId]["ajaxPreloader"].render();

    };

    output += preloader;

    return output; 

};
